import React, { Component } from 'react';
import { Text, View, Platform, TextInput, Keyboard, StyleSheet } from 'react-native';
import { OPComponent, ImageView, NavBar, Utils, Navigation } from '../components';
import { COLOR, THEME } from '../../constants/styles';

export default class AddImage extends OPComponent {
  static navigatorStyle = NavBar && NavBar.navigatorStyleRootScreen;
  static navigatorButtons = NavBar && {
    leftButtons: [NavBar.buttons.cancel],
    rightButtons: [
      {
        text: 'Add',
        id: 'save',
      },
    ],
  };

  constructor(props) {
    super(props);

    const generateThumb = props.generateThumb && props.image?.type?.startsWith?.('video');

    this.state = {
      comment: null,
      thumbnailUri: generateThumb ? null : props.image?.uri,
    };

    if (generateThumb) {
      this.generateThumb(props.image?.uri);
    }
  }

  generateThumb = async (uri) => {
    try {
      const thumbResult = await Utils.createThumbnail(uri);
      this.setState({ thumbnailUri: thumbResult.path });
    } catch (e) {
      // console.info('Error getting thumbnail', e);
    }
  };

  navigationButtonPressed = ({ buttonId }) => {
    const { componentId } = this.props;
    if (
      NavBar.handleButtonPress(componentId, buttonId, {
        asModal: true,
        onSave: this.onSave,
      })
    )
      return;
  };

  componentDidMount() {
    Utils.trackScreen('Messaging', 'Add Image');
    Navigation.registerForButtonEvents(this);
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  onSave = () => {
    Utils.trackEvent('Action', 'Tap', 'Add Image');
    Keyboard.dismiss();
    this.props.onAdd({
      image: this.props.image,
      comment: this.state.comment,
      thumbnailUri: this.state.thumbnailUri,
    });
    Navigation.dismissModal(this.props.componentId);
  };

  handleChangeText(stateAttrName, text) {
    // don't trigger a re-render unless the value is newly empty or newly not empty
    if (!text || !this.state[stateAttrName]) {
      this.setState({
        [stateAttrName]: text,
      });
    } else {
      this.state[stateAttrName] = text;
    }
  }

  render() {
    let { image } = this.props;

    return (
      <View style={styles.container}>
        <View style={styles.imageContainer}>
          {!!this.state.thumbnailUri && (
            <ImageView
              imageUri={this.state.thumbnailUri}
              containerStyle={styles.imageWrapperStyle}
            />
          )}
        </View>

        <View style={styles.commentContainer}>
          <Text style={styles.labelText}>{this.state.comment ? 'ADD COMMENT' : ''}</Text>
          <View style={styles.inputContainer}>
            <TextInput
              style={styles.input}
              autoFocus={false}
              defaultValue={this.state.comment ? this.state.comment : null}
              placeholder="ADD COMMENT"
              placeholderTextColor={COLOR.text}
              autoCapitalize="sentences"
              keyboardType="default"
              returnKeyType="done"
              selectTextOnFocus={true}
              clearButtonMode="while-editing"
              onChangeText={(text) => {
                this.handleChangeText('comment', text);
              }}
              onSubmitEditing={() => {}}
              underlineColorAndroid="transparent"
            />
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: THEME.container,
  input: THEME.input,
  labelText: THEME.labelText,
  imageContainer: {
    padding: 10,
    backgroundColor: COLOR.altContrast,
    alignItems: 'center',
  },
  imageWrapperStyle: {
    borderRadius: 15,
    overflow: 'hidden',
  },
  commentContainer: {
    paddingVertical: 20,
    paddingHorizontal: 35,
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: COLOR.textLight,
  },
});
